import { useCallback } from 'react';
import { buildCertificateLink, copyToClipboard } from '@/shared/utils/clipboard';

export function useCertificateLink(): {
  copyCertificateLink: (shareId: string) => void;
  openCertificate: (shareId: string) => void;
} {
  const copyCertificateLink = useCallback((shareId: string): void => {
    copyToClipboard(buildCertificateLink(shareId));
  }, []);

  const openCertificate = useCallback((shareId: string): void => {
    window.open(buildCertificateLink(shareId), '_blank', 'noopener,noreferrer');
  }, []);

  return { copyCertificateLink, openCertificate };
}
